<template>
  <div class="dialog-margin clause-dialog">
    <el-table :data="list">
      <el-table-column label="溢装">
        <template slot-scope="scope">
          +
          <qx-input-number v-model="scope.row.overflow" :controls="false"/>
          %
        </template>
      </el-table-column>
      <el-table-column label="短装">
        <template slot-scope="scope">
          -
          <qx-input-number v-model="scope.row.shortV" :controls="false"/>
          %
        </template>
      </el-table-column>
    </el-table>
    <div class="control-button padding-10">
      <el-button type="primary" @click="submit">确定</el-button>
      <el-button @click="close">关闭</el-button>
    </div>
  </div>
</template>

<script>
/**
 * @Description: 短溢装弹窗
 * @Author: 菩萨蛮
 * @Date: 2021/3/24 7:07 上午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */

export default {
  name: 'ClauseDialog',
  props: {
    shortV: { type: Number, default: 0 },
    overflow: { type: Number, default: 0 }
  },
  created() {
    this.list[0].shortV = this.shortV;
    this.list[0].overflow = this.overflow;
  },
  data() {
    return {
      list: [
        { shortV: 0, overflow: 0 }
      ]
    };
  },
  methods: {
    submit() {
      this.$emit('submit', { shortV: this.list[0].shortV, overflow: this.list[0].overflow });
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>

.el-input-number {
  width: 100px;
}

</style>
